import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '42px',
    borderRadius: '8px',
    borderColor: state.isFocused ? '#0066cc' : '#e1e4e8',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(0,102,204,0.08)' : 'none',
    backgroundColor: 'white',
    '&:hover': {
      borderColor: '#999'
    }
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#203c58ff' : state.isFocused ? '#e3f2fd' : 'white',
    color: state.isSelected ? 'white' : '#42526E',
    cursor: 'pointer',
    padding: '10px 12px'
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1000,
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: '300px'
  }),
  placeholder: (base) => ({
    ...base,
    color: '#999'
  }),
  singleValue: (base) => ({
    ...base,
    color: '#42526E'
  })
};

export default function SearchableSelect({ 
  label, 
  value, 
  options, 
  onChange, 
  isMulti = false,
  isClearable = true,
  isSearchable = true,
  required = false,
  error = null,
  placeholder = 'Select...'
}) {
  // Transform options to react-select format if needed
  const selectOptions = options.map(opt => ({
    value: opt.value,
    label: opt.label
  }));

  // Find the selected option(s)
  const selectedOption = value 
    ? selectOptions.find(opt => opt.value === value)
    : null;

  const handleChange = (selected) => {
    if (onChange) {
      // Create a synthetic event-like object for compatibility
      onChange({
        target: {
          value: selected ? (Array.isArray(selected) ? selected.map(s => s.value) : selected.value) : ''
        }
      });
    }
  };

  return (
    <div style={{ marginBottom: '10px' }}>
      {label && (
        <label style={{ display: 'block', marginBottom: '4px', color: '#6B778C', fontSize: '14px' }}>
          {label}
          {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
        </label>
      )}
      <Select
        value={selectedOption}
        options={selectOptions}
        onChange={handleChange}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        placeholder={placeholder}
        styles={customStyles}
        classNamePrefix="react-select"
      />
      {error && (
        <div style={{ color: '#de350b', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </div>
  );
}
